import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useRenewAccessTokenMutation } from 'gql/index';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

export const LegacyTokenPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { formatMessage } = useIntl();
  const [hasRequested, setHasRequested] = useState(false);
  
  const { mutate: renewToken, isPending } = useRenewAccessTokenMutation({
    onSuccess: (data) => {
      data.renewAccessTokenFromExpiredToken.errors
      setHasRequested(true);
    },
  });

  const handleRequestNewLink = () => {
    if (token) {
      renewToken({ token });
    }
  };

  if (hasRequested) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" p={3}>
        <Stack spacing={3} maxWidth={600} textAlign="center">
          <Alert severity="success">
            {formatMessage({ id: 'A new access link has been sent to your email address.' })}
          </Alert>
          <Typography variant="body1">
            {formatMessage({ id: 'Please check your email inbox for the new link.' })}
          </Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" p={3}>
      <Stack spacing={3} maxWidth={600} textAlign="center">
        <Typography variant="h5">
          {formatMessage({ id: 'This access link is no longer valid.' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'The link you used has expired. Please request a new access link to continue.' })}
        </Typography>
      

        <Button
          variant="contained"
          onClick={handleRequestNewLink}
          disabled={isPending || !token}
          size="large"
        >
          {isPending ? (
            <CircularProgress size={24} />
          ) : (
            formatMessage({ id: 'Request New Access Link' })
          )}
        </Button>
      </Stack>
    </Box>
  );
};
